import { request } from "../utils/request.js"

export const sysMenu_findAllTree = (args) => request({
    url: 'sysMenu/findAllTree',
    method: 'GET',
    showFailMessage: true,
    ...args
})


export const sysMenu_findUnFrozenTree = (args) => request({
    url: 'sysMenu/findUnFrozenTree',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const sysMenu_addNew = (pojo, args) => request({
    url: 'sysMenu/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysMenu_update = (pojo, args) => request({
    url: 'sysMenu/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysMenu_findById = (id, args) => request({
    url: 'sysMenu/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const sysMenu_deleteById = (id, args) => request({
    url: 'sysMenu/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysMenu_getRouters = (args) => request({
    url: 'sysMenu/getRouters',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const sysMenu_changeFrozenStatus = (id, args) => request({
    url: 'sysMenu/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysMenu_flushCacheForTenantMenu = (args) => request({
    url: 'sysMenu/flushCacheForTenantMenu',
    method: 'GET',
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/sysMenu.js